import { createCarousel, CarouselConfig } from "utils/carousel"
import "./index.scss"

require.context("./static", true, /\.jpg|svg$/)

// Component-specific configuration
const config: CarouselConfig = {
  carouselSelector: ".carousel-news-posts__carousel",
  slideSelector: ".carousel-news-posts__carousel__slide",
  slideGap: 20,
  cssClass: "carousel-news-posts",
}

// Export the configured carousel instance
export const CarouselNewsPosts = createCarousel(config)
